import * as Roles from "@/constants/roles";

const ALL_ROLES = [
  Roles.CREDIT,
  Roles.PRICING_TEAM,
  Roles.TELNET,
  Roles.CUSTOMER_MANAGER,
  Roles.LOYALTY_MARKETING,
  Roles.SUPPORT
];

export const DECLINED_TRANSACTIONS_ROUTE_NAMES = {
  SEARCH_DECLINED_TRANSACTIONS: "search-declined-transactions",
  DECLINED_TRANSACTION_DETAIL: "delined-transaction-detail"
};

export const DECLINED_TRANSACTIONS_ROUTES = [
  {
    name: DECLINED_TRANSACTIONS_ROUTE_NAMES.SEARCH_DECLINED_TRANSACTIONS,
    path: "/declined-transactions/",
    component: () =>
      import(/* webpackChunkName: "loyaltyCustomers" */ "./views/DeclinedTransactions/SearchTransactions.vue"),
    meta: {
      display: "Declined Transactions",
      requireRole: ALL_ROLES,
      label: "Search declined transactions",
      parentName: DECLINED_TRANSACTIONS_ROUTE_NAMES.SEARCH_DECLINED_TRANSACTIONS,
      submenu: DECLINED_TRANSACTIONS_ROUTE_NAMES.SEARCH_DECLINED_TRANSACTIONS,
      sortOrder: 1
    }
  },
  {
    name: DECLINED_TRANSACTIONS_ROUTE_NAMES.DECLINED_TRANSACTION_DETAIL,
    path: "/declined-transactions/:id",
    props: true,
    component: () =>
      import("./views/DeclinedTransactions/Detail.vue"),
    meta: {
      requireRole: ALL_ROLES,
      parentName: DECLINED_TRANSACTIONS_ROUTE_NAMES.SEARCH_DECLINED_TRANSACTIONS,
      submenu: DECLINED_TRANSACTIONS_ROUTE_NAMES.SEARCH_DECLINED_TRANSACTIONS,
    }
  }

];
